





































import { Component, Vue } from 'vue-property-decorator'

import { bus, zirafHTTP } from '@/main'
import GlobalMixins from './mixins'

@Component
export default class App extends GlobalMixins {
	initComplete: boolean = false
	modal: {
		message: string
		confirm: {
			label: string
			event: string
		}
		reject: {
			label: string
			event: string
		}
	} | false = false
	notification: {
		error?: boolean
		message: string
	} | false = false
	notificationTimeOut: any = false
	tokenCheckInterval: any = false

	confirm(): void {
		if (!this.modal) return

		bus.$emit(this.modal.confirm.event)

		Vue.nextTick(() => {
			this.modal = false
		})
	}
	reject(): void {
		if (!this.modal) return

		bus.$emit(this.modal.reject.event)

		Vue.nextTick(() => {
			this.modal = false
		})
	}
	closeModal(e: any) {
		if (e.target === this.$refs.zirafModal) {
			this.modal = false
		}
	}

	created() {
		bus.$on('initComplete', () => {
			this.initComplete = true
		})
		bus.$on('openModal', (modal: {
			message: string
			confirm: {
				label: string
				event: string
			}
			reject: {
				label: string
				event: string
			}
		}) => {
			this.modal = modal
		})
		bus.$on('pushNotification', (notification: {
			error?: boolean
			message: string
		}) => {
			clearTimeout(this.notificationTimeOut)

			this.notification = notification

			this.notificationTimeOut = setTimeout(() => {
				this.notification = false
			}, 4400)
		})
		bus.$on('routeChange', () => {
			this.modal = false
		})

		window.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.modal = false
			}
		})

		this.tokenCheckInterval = setInterval(() => {
			if (this.$route.name !== 'login' && this.$route.name !== 'pageNotFound') {
				zirafHTTP.get('auth/check-token')
					.catch(error => {
						console.error(error.response.data)

						window.localStorage.removeItem('accessToken')

						this.$store.dispatch('setLoginError', this.returnErrorByCode(error.response.data.errorCode))
						
						this.$router.push({ name: 'login' })
					})
			}
		}, 300000) // Check login token every 5 minutes
	}
	beforeDestroy() {
		clearInterval(this.tokenCheckInterval)
	}
}
